import { Injectable } from '@angular/core';
import { ScenarioSankeyStatesEnum } from '../enums/ScenarioSankeyStatesEnum';
import { ScenarioResultStore } from '../stores/scenario-result.store';

@Injectable({
  providedIn: 'root',
})
export class ScenarioResultFacade {
  constructor(private readonly _scenarioResultStore: ScenarioResultStore) {}

  public resultState$ = this._scenarioResultStore.resultState$;

  public get resultState() {
    return this._scenarioResultStore.resultState;
  }

  public set resultState(resultState) {
    this._scenarioResultStore.resultState = resultState;
  }

  public setResultState(uuid: string, value: ScenarioSankeyStatesEnum) {
    return this._scenarioResultStore.setResultState(uuid, value);
  }

  public getResultState(uuid: string) {
    return this._scenarioResultStore.getResultState(uuid);
  }
}
